import { useQuery, useQueryClient } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getPageKey, getSpaceKey } from '../../utils/keys';
export const usePage = (options) => {
    const { variables, fields = 'default', useQueryOptions } = options;
    const { client } = useTribeClient();
    const pageKey = getPageKey({ variables, fields });
    const queryClient = useQueryClient();
    return useQuery(pageKey, () => client.spaces.getByPath(variables, fields), {
        onSuccess: data => {
            var _a, _b;
            if ((_a = data === null || data === void 0 ? void 0 : data.space) === null || _a === void 0 ? void 0 : _a.id) {
                const spaceKey = getSpaceKey({
                    fields: 'default',
                    variables: { id: (_b = data === null || data === void 0 ? void 0 : data.space) === null || _b === void 0 ? void 0 : _b.id },
                });
                queryClient.setQueryData(spaceKey, data === null || data === void 0 ? void 0 : data.space);
            }
        },
        ...useQueryOptions,
    });
};
//# sourceMappingURL=usePage.js.map